export class Config {
  public static config = {
    theme: 'collapsed', // default, collapsed, horizontal
    themeType: 'light' // default, dark, light
  };
}
